import React from 'react'
import { Decorator } from '@/types'
import Icon, { IconName } from '@/components/Icons'
import { decoratorIcons } from '@/helpers/DecoratorHelper'
import { Wrapper } from './TitleDecorator.styles'

const TitleDecorator: React.FC<{ label: string; icon?: IconName; decoratorKey?: Decorator['key']; color?: string }> = ({
  label,
  icon,
  decoratorKey,
  color = 'var(--brand-secondary)',
}) => {
  return (
    <Wrapper color={color}>
      {icon && <Icon name={icon} data-testid="regular-icon" />}
      {decoratorKey && <Icon name={decoratorIcons[decoratorKey]} data-testid="decorator-icon" />}
      {label}
    </Wrapper>
  )
}

export default TitleDecorator
